import { useEffect } from 'react'

import { FallbackProps } from 'react-error-boundary'
import { ErrorView } from 'components/QueryBoundaries/ErrorView'
import { tagEvent } from 'utils/tagging'
import { TTagging } from 'interface'

import { TrackData } from '@interco/track'

import * as S from '../styles'

export const ErrorWrapperView = ({ error }: FallbackProps) => {
  useEffect(() => {
    tagEvent({
      type: 'ETHOCA_FLUXO_ACESSO',
      content_action: 'Dado carregado',
      screen: 'Erro acesso',
    } as TTagging)
  }, [])

  TrackData.error({
    key: 'ERROR_BOUNDARY_CATCH',
    error: error?.toString(),
  })

  return (
    <S.Wrapper>
      <ErrorView />
    </S.Wrapper>
  )
}

export default ErrorWrapperView
